import { device_px, yellow } from "@/styles/variable"
import styled from "styled-components"

const { MAX_1279 } = device_px

export const ViewFullScheduleButtonText = styled.button`
  background: transparent;
  border: none;
  color: ${yellow.FF};
  text-align: center;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 28.8px */
  letter-spacing: 0.36px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: ${MAX_1279}) {
    font-size: 12px;
  }
`
